/** Unit types, read from the estimate export. */
import { EstimateData } from "../../interfaces/EstimateData";
import { Unit, UnitTypeUnitSpecAssociation } from "../../interfaces/Unit";

type ExportUnitSpecAssociation = UnitTypeUnitSpecAssociation & { unit_type: string };

export const getEstimateUnits = (estimateData: EstimateData): Unit[] => {
  const associationsByUnit = new Map<string, UnitTypeUnitSpecAssociation[]>();
  for (const association of (estimateData.unit_type_unit_spec_associations ?? []) as ExportUnitSpecAssociation[]) {
    const forUnit = associationsByUnit.get(association.unit_type) ?? [];
    forUnit.push(association);
    associationsByUnit.set(association.unit_type, forUnit);
  }
  return ((estimateData.unit_types ?? []) as Unit[]).map((unit) => ({
    ...unit,
    unit_type_unit_spec_associations: associationsByUnit.get(unit.id) ?? [],
  }));
};
